export default __webpack_public_path__ + "static/media/img-sandraantiquera.d52fc36e.jpg";